<div class="layout-col full">
  <elder-table
    class="flex"
    matSort
    [data]="data"
    [selectionMultiEnabled]="enableSelection()"
    [selectionVisible]="enableSelection()"
    [interactionMode]="enableSelection() ? 'selection' : 'open'"
    (selectionChange)="onSelectionChange($event)"
    (itemClick)="openDetail($event)"
  >
    @if (enableSelection()) {
      <elder-data-toolbar *elderTableToolbar [canMore]="false" [canAdd]="false" [canRemove]="false">
        <ng-template elderToolbarContent="main">
          <app-work-item-filter
            [data]="data"
            [involvedProcessPlans]="involvedProcessPlans$ | async"
          >
          </app-work-item-filter>
        </ng-template>
      </elder-data-toolbar>
    }

    <!-- number Column -->
    <ng-container matColumnDef="number">
      <th mat-header-cell *matHeaderCellDef class="cell-10" mat-sort-header>
        {{ 'context.number' | translate }}
      </th>
      <td mat-cell *matCellDef="let item">{{ item.number }}</td>
    </ng-container>

    <!-- description Column -->
    <ng-container matColumnDef="description">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="description" class="cell-15">
        {{ 'context.description' | translate }}
      </th>
      <td mat-cell *matCellDef="let item">
        <div class="layout-col">
          <span>{{ item.description }}</span>
          <span class="text-body-small">{{ item.orderedProduct?.materialId }}</span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="length">
      <th
        mat-header-cell
        elderNumberCell
        *matHeaderCellDef
        mat-sort-header="dimensions.length"
        class="cell-15"
      >
        {{ 'context.length' | translate }}
      </th>
      <td mat-cell elderNumberCell *matCellDef="let item">
        <div class="layout-col">
          <span>{{
            toQuantity(item?.dimensions?.length, item.dimensions?.unit)
              | elderQuantity: false : Unit.cm
          }}</span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="width">
      <th
        mat-header-cell
        elderNumberCell
        *matHeaderCellDef
        mat-sort-header="dimensions.width"
        class="cell-15"
      >
        {{ 'context.width' | translate }}
      </th>
      <td mat-cell elderNumberCell *matCellDef="let item">
        <div class="layout-col">
          <span>{{
            toQuantity(item?.dimensions?.width, item.dimensions?.unit)
              | elderQuantity: false : Unit.cm
          }}</span>
        </div>
      </td>
    </ng-container>

    <!-- mainProductQuantity Column -->
    <ng-container matColumnDef="mainProductQuantity">
      <th
        mat-header-cell
        elderNumberCell
        *matHeaderCellDef
        mat-sort-header="orderedProduct.quantity"
        arrowPosition="before"
        class="cell-10 align-right"
      >
        {{ 'context.quantity' | translate }}
      </th>
      <td mat-cell elderNumberCell *matCellDef="let item" class="align-right">
        {{ item.orderedProduct | productSalesQuantity | elderQuantity }}
      </td>
    </ng-container>

    <!-- totalWeight Column -->
    <ng-container matColumnDef="totalWeight">
      <th mat-header-cell elderNumberCell *matHeaderCellDef mat-sort-header="totalWeight.value">
        {{ 'context.weight' | translate }}
      </th>
      <td mat-cell elderNumberCell *matCellDef="let item">
        {{ item?.totalWeight | elderQuantity: false : Unit.kg : '1.0-0' }}
      </td>
    </ng-container>

    <!-- manufacturingStatus Column -->
    <ng-container matColumnDef="manufacturingStatus">
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header="productionRoute.productionPath"
        class="cell-15"
      >
        {{ 'manufacturing.title' | translate }}
      </th>
      <td mat-cell *matCellDef="let item">
        <app-item-manufacturing-status style="width: 100%" [item]="item">
        </app-item-manufacturing-status>
      </td>
    </ng-container>
  </elder-table>
</div>
